<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Emendas Parlamentares</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Lista de emendas parlamentares"
            report-title="Emendas Parlamentares"
            :initial-page="pagina"
            api-url="emenda"
            :fields="fields"
            :pageCollection="'emendasParlamentares'"
            :append-params="filtros"
            :slots="slots"
          >
            <template slot="filters">
              <div class="collapse in" id="filtros">
                <div class="col-sm-3">
                  <label class="primary" for="numero_filter">Número</label>
                  <input
                    type="text"
                    v-model="numero"
                    class="form-control"
                    name="numero_filter"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="ano_filter">Ano</label>
                  <input
                    type="text"
                    v-model="ano"
                    class="form-control"
                    name="ano_filter"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="vereador_filter">Vereador</label>
                  <select
                    v-model="vereador"
                    name="vereador_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option
                      v-for="vereador in vereadores"
                      :key="vereador.id"
                      :value="vereador.id"
                    >
                      {{ vereador.nome.toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="sigla_orgao_filter"
                    >Sigla Orgão</label
                  >
                  <select
                    v-model="sigla_orgao"
                    name="sigla_orgao_filter"
                    class="form-control select-selected"
                  >
                    <option value="">Todos</option>
                    <option v-for="orgao in orgaos">
                      {{ orgao.sigla }}
                    </option>
                  </select>
                </div>

                <div class="col-sm-3">
                  <label class="primary" for="processo_filter">Processo</label>
                  <input
                    type="text"
                    v-model="numero_processo"
                    class="form-control"
                    name="processo_filter"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="descricao_filter"
                    >Descrição</label
                  >
                  <input
                    type="text"
                    v-model="descricao"
                    class="form-control"
                    name="descricao_filter"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="resumo_utilizacao_filter"
                    >Resumo da utilização</label
                  >
                  <input
                    type="text"
                    v-model="resumo_utilizacao"
                    class="form-control"
                    name="resumo_utilizacao_filter"
                  />
                </div>
                <div class="col-sm-3">
                  <label class="primary" for="processos_pagamento_filter"
                    >Processo de pagamento</label
                  >
                  <input
                    type="text"
                    v-model="processos_pagamento"
                    name="processos_pagamento_filter"
                    class="form-control select-selected"
                  />
                </div>
                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                :to="{ name: 'user_salvar_emenda' }"
                class="btn btn-default"
              >
                <font-awesome-icon :icon="'plus'"></font-awesome-icon>
                Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="button-wrapper">
                <button
                  title="Lista de processos de pagamento"
                  type="button"
                  class="btn btn-primary"
                  @click="listarProcessos(props.rowData)"
                >
                  <font-awesome-icon :icon="'list-ol'"></font-awesome-icon>
                </button>
                <button
                  title="Editar"
                  type="button"
                  class="btn btn-primary"
                  @click="editar(props.rowData)"
                >
                  <font-awesome-icon :icon="'edit'"></font-awesome-icon>
                </button>
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <span class="sr-only">Botão Excluir</span>
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
                <button
                  title="Remanejar"
                  type="button"
                  class="btn btn-primary"
                  @click="remajenar(props.rowData)"
                >
                  <span class="sr-only">Botão de Remanejar</span>
                  <font-awesome-icon icon="exchange-alt"></font-awesome-icon>
                </button>
                <button
                  title="Anexos"
                  type="button"
                  class="btn btn-primary"
                  @click="exibirAnexos(props.rowData)"
                >
                  <span class="sr-only">Botão de exibir anexos</span>
                  <font-awesome-icon icon="file-alt"></font-awesome-icon>
                </button>
              </div>
            </template>
            <template slot="descricao" slot-scope="props">
              <span v-if="props.rowData.descricao.length < 100">{{
                props.rowData.descricao
              }}</span>
              <span v-else>{{
                props.rowData.descricao.substring(0, 100) + '...'
              }}</span>
              <font-awesome-icon
                :icon="'search'"
                @click="showModal('Descrição', props.rowData.descricao)"
              />
            </template>
            <template slot="saldo" slot-scope="props">
              {{ getSaldo(props.rowData) }}
            </template>
            <template slot="resumo_utilizacao" slot-scope="props">
              <span
                v-if="
                  props.rowData.resumo_utilizacao
                    ? props.rowData.resumo_utilizacao.length < 25
                    : ''
                "
                >{{ props.rowData.resumo_utilizacao }}</span
              >
              <span
                v-else-if="
                  props.rowData.resumo_utilizacao
                    ? props.rowData.resumo_utilizacao.length > 25
                    : ''
                "
                >{{
                  props.rowData.resumo_utilizacao.substring(0, 25) + '...'
                }}</span
              >
              <span v-else>
                Nenhum resumo de utilização registrado.
              </span>
              <font-awesome-icon
                :icon="'search'"
                class="fa-w-18"
                @click="
                  showModal(
                    'Resumo de utilização',
                    props.rowData.resumo_utilizacao
                  )
                "
              />
              <font-awesome-icon
                :icon="'edit'"
                class="fa-search fa-w-18"
                @click="
                  getEmendaDados(props.rowData)
                  openResumoModal()
                "
              />
            </template>
          </list>
          <!--Modal para editar resumo de utilização-->
          <div
            id="modal_resumo_utilizacao"
            class="modal fade"
            tabindex="-1"
            role="dialog"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Fechar"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    Editar resumo de utilização da emenda número
                    {{ numero_emenda_selecionado }}
                  </h4>
                </div>
                <div class="modal-body">
                  <textarea
                    id="textAreaResumo"
                    class="form-control"
                    rows="8"
                    @input="updateResumoModal($event.target.value)"
                    >{{ resumo_utilizacao_selecionado }}</textarea
                  >
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    @click="saveResumoModal()"
                    :disabled="desativado"
                  >
                    <font-awesome-icon :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="modal_anexos" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Fechar"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">
                    Anexos da emenda {{ emenda_anexos.numero }} /
                    {{ emenda_anexos.ano }}
                  </h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-xs-12">
                      <PDFImport ref="upload" @loadFile="setFile" />
                      <button
                        class="btn btn-default"
                        :disabled="arquivo_upload.length"
                        @click="uploadFile()"
                      >
                        <font-awesome-icon :icon="'save'"></font-awesome-icon>
                        Gravar arquivo
                      </button>
                    </div>
                  </div>
                  <div class="row" v-if="lista_anexos.length">
                    <div class="col-xs-12">
                      <h4>Lista de arquivos</h4>
                    </div>
                    <div
                      v-for="anexo in lista_anexos"
                      class="col-xs-12 table table-striped"
                      :key="'anexo-' + anexo.id"
                    >
                      <a role="button" @click="downloadFile(anexo)">
                        {{ anexo.nome }}
                      </a>
                      -
                      <span
                        role="button"
                        class="is-danger"
                        title="excluir"
                        @click="mensagemExclusao(anexo)"
                      >
                        <span class="sr-only">Botão de excluir anexo</span>
                        <font-awesome-icon
                          icon="trash-alt"
                          alt="Imagem de uma lixeira usada para representar exclusão"
                        ></font-awesome-icon>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cleanFile()"
                  >
                    <font-awesome-icon :icon="'times'" />
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DataTable as List, PDFImport } from '@/components/common'
import { request } from '@/request'
import { formatarMoeda } from '@/utils'

export default {
  name: 'emendas-parlamentares',
  inject: ["showConfirm"],
  components: {
    List,
    PDFImport
  },
  data() {
    return {
      emenda_codigo_selecionado: '',
      numero_emenda_selecionado: '',
      resumo_utilizacao_selecionado: '',
      resumo_original: '',
      desativado: false,
      arquivo_upload: '',
      orgaos: [],
      vereadores: [],
      emenda_anexos: {},
      lista_anexos: [],
      processos_pagamento_numero: [],
      slots: ['descricao', 'resumo_utilizacao', 'saldo'],
      fields: [
        {
          name: 'numero',
          title: 'Número',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'ano',
          title: 'Ano',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'vereador.nome',
          title: 'Vereador',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'sigla_orgao',
          title: 'Sigla',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'numero_processo',
          title: 'Processo',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'valor',
          title: 'Valor',
          dataClass: 'align-middle text-right',
          filterable: true,
          callback(value) {
            return formatarMoeda(value)
          }
        },
        {
          name: '__slot:saldo',
          title: 'Saldo',
          dataClass: 'align-middle text-right'
        },
        {
          name: '__slot:descricao',
          title: 'Descrição',
          dataClass: 'align-middle',
          filterable: true,
          width: '20%'
        },
        {
          name: 'processos_pagamento',
          title: 'Processos de pagamento',
          dataClass: 'align-middle',
          filterable: true,
          callback(value) {
            return value.length === 0
              ? 'Nenhum processo de pagamento de encontrado.'
              : value.map(numero => numero.numero_pagamento).join(', ')
          }
        },
        {
          name: '__slot:resumo_utilizacao',
          title: 'Resumo de utilização',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-2',
          dataClass: 'text-center'
        }
      ]
    }
  },
  mounted() {
    request
      .get('listar-vereadores')
      .then(resp => {
        if (resp.length === 0) return
        this.vereadores = resp.data
      })
      .catch(resp => {
        console.log(resp)
      })

    request
      .get('processospagamento')
      .then(resp => {
        if (resp.length === 0) return
        this.processos_pagamento_numero = resp.data.data
      })
      .catch(resp => {
        console.log(resp)
      })

    request
      .get('unidade-organizacional/orgaos')
      .then(resp => {
        if (resp.length === 0) return
        this.orgaos = resp.data
      })
      .catch(resp => {
        console.log(resp)
      })
  },
  computed: {
    filtros() {
      const {
        ano,
        vereador,
        processos_pagamento,
        sigla_orgao,
        numero,
        numero_processo,
        descricao,
        resumo_utilizacao
      } = this

      return {
        ano,
        vereador,
        processos_pagamento,
        sigla_orgao,
        numero,
        numero_processo,
        descricao,
        resumo_utilizacao
      }
    },
    pagina: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { pagina } = emendasParlamentares
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'emendasParlamentares',
          value: value
        })
      }
    },
    ano: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { ano } = emendasParlamentares.filtros
        return ano
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'ano',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    vereador: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { vereador } = emendasParlamentares.filtros
        return vereador
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'vereador',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    sigla_orgao: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { sigla_orgao } = emendasParlamentares.filtros
        return sigla_orgao
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'sigla_orgao',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    numero: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { numero } = emendasParlamentares.filtros
        return numero
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    numero_processo: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { numero_processo } = emendasParlamentares.filtros
        return numero_processo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'numero_processo',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    descricao: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { descricao } = emendasParlamentares.filtros
        return descricao
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'descricao',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    processos_pagamento: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { processos_pagamento } = emendasParlamentares.filtros
        return processos_pagamento
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'processos_pagamento',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    },
    resumo_utilizacao: {
      get() {
        const { emendasParlamentares } = this.$store.state.vuetableState
        const { resumo_utilizacao } = emendasParlamentares.filtros
        return resumo_utilizacao
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'resumo_utilizacao',
          collection: 'emendasParlamentares',
          value: value
        })
        this.resetPageStore()
      }
    }
  },
  methods: {
    mensagemExclusao(anexo) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          this.excluirAnexo(anexo)
        }
      }

      this.showConfirm(
        `Deseja realmente excluir o anexo ${anexo.nome}?`,
        config
      )
    },
    excluirAnexo(anexo) {
      const { id } = anexo
      request
        .post('emendas/excluir-anexo', { id })
        .then(response => {
          const { data } = response
          this.$toastr.s('Anexo excluído com sucesso')
          console.log(data)
          this.exibirAnexos({ ...this.emenda_anexos })
        })
        .catch(error => {
          this.$toastr.e('Houve um erro ao excluir o anexo. Tente novamente')
          console.log(error.response)
        })
      console.log(anexo)
    },
    cleanFile() {
      this.$refs.upload.clean()
    },
    setFile(file) {
      this.arquivo_upload = file
    },
    uploadFile() {
      if (!this.arquivo_upload) {
        this.$toastr.e('Selecione o arquivo a ser importado')
        return
      }

      const data = new FormData()
      data.append('file', this.arquivo_upload)
      data.append('emenda_id', JSON.stringify(this.emenda_anexos.id))

      request
        .post('emendas/salvar-anexo', data)
        .then(response => {
          this.$toastr.s('Arquivo anexado com sucesso')
          this.exibirAnexos({ ...this.emenda_anexos })
          this.cleanFile()
        })
        .catch(error => {
          this.$toastr.e('Houve um erro ao anexar o arquivo. Tente novamente')
          console.log(error.response)
        })
    },
    downloadFile(anexo) {
      const { nome, id } = anexo
      request
        .get(`emendas/download-anexo/${id}`)
        .then(response => {
          const { data } = response
          const link = document.createElement('a')
          link.download = nome
          link.href = data
          link.target = '_blank'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(error => {
          this.$toastr.e('Houve um erro ao baixar o anexo. Tente novamente')
          console.log(error.response)
        })
    },
    exibirAnexos(emenda) {
      this.emenda_anexos = emenda

      request
        .get(`emendas/listar-anexos/${this.emenda_anexos.id}`)
        .then(response => {
          const { data } = response
          this.lista_anexos = data
          window.jQuery('#modal_anexos').modal('show')
        })
        .catch(error => {
          this.$toastr.e('Houve um erro ao listar os anexos. Tente novamente')
          console.log(error.response)
        })
    },
    getSaldo(emenda) {
      const reducer = (accum, proc) => {
        return (accum += Number(proc.valor))
      }

      const somaProcessos = emenda.processos_pagamento.reduce(reducer, 0)

      return formatarMoeda(emenda.valor - somaProcessos)
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'emendasParlamentares',
        value: 1
      })
    },
    editar(data) {
      const { id } = data
      this.$router.push({ name: 'user_salvar_emenda', params: { id } })
    },
    remajenar(data) {
      this.$router.push({ name: 'user_remanejamento', params: { ...data } })
    },
    listarProcessos(data) {
      const { id } = data
      this.$router.push({
        name: 'user_list_emenda_processos',
        params: { id }
      })
    },
    getEmendaDados(data) {
      const { id } = data
      const { numero } = data
      const { resumo_utilizacao } = data
      this.emenda_codigo_selecionado = id
      this.numero_emenda_selecionado = numero
      this.resumo_original = resumo_utilizacao

      if (window.jQuery('#modal_resumo_utilizacao').modal('hide')) {
        document.getElementById('textAreaResumo').value = this.resumo_original
      }
    },
    showModal(title, msg, success) {
      this.showConfirm(msg, { title, question: false, yes: success })
    },
    openResumoModal() {
      this.resumo_utilizacao_selecionado = this.resumo_original
      window.jQuery('#modal_resumo_utilizacao').modal('show')

      if (
        document.getElementById('textAreaResumo').value == this.resumo_original
      )
        this.desativado = true
    },
    updateResumoModal(value) {
      document.getElementById('textAreaResumo').value == this.resumo_original
        ? (this.desativado = true)
        : (this.desativado = false)
      this.resumo_utilizacao_selecionado = value
    },
    saveSuccess(result) {
      this.$toastr.s('Resumo de utilização editado com sucesso!')
      this.$refs.vuetable.refresh()
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar editar o resumo.')
    },
    saveResumoModal() {
      if (this.emenda_codigo_selecionado) {
        request
          .put(
            `emenda/${this.emenda_codigo_selecionado}/resumoutilizacao/update`,
            {
              resumo_utilizacao: this.resumo_utilizacao_selecionado
            }
          )
          .then(this.saveSuccess)
          .catch(this.saveFail)
      }
    },
    verificarResumoUtilizacao() {
      console.log(this.resumo_utilizacao_selecionado)
    },
    excluir(data) {
      const me = this
      const { id, id_emenda_origem } = data

      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(`emenda/${id}`)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Emenda removida com sucesso!')
            })
            .catch(error => {
              const { response } = error

              if (response.status === 403) {
                me.$toastr.e(response.data)
                return
              }

              me.$toastr.e(
                'Houve uma falha ao tentar remover esse item, por favor, tente novamente mais tarde!'
              )
            })
        }
      }

      const complemento = id_emenda_origem
        ? ' <br/><b>Esta emenda foi remanejada e o seu saldo voltará a emenda original.</b>'
        : ''

      this.showConfirm(
        'Deseja realmente deletar este item?' + complemento,
        config
      )
    },
    consultar() {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.ano = ''
      this.vereador = ''
      this.sigla_orgao = ''
      this.numero = ''
      this.numero_processo = ''
      this.descricao = ''
      this.processos_pagamento = ''
      this.resumo_utilizacao = ''
    }
  }
}
</script>

<style scoped>
.fa-search {
  color: #00615c;
  margin-left: 5px;
}

.fa-search:hover {
  cursor: pointer;
}

textarea {
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/emendas-parlamentares/emendas/index.vue